import React from 'react';
import { FormBuilder } from 'commons-ui';
import useCreate from './useCreate';
import { FORM_FIELD_CREATE_CONFIG, FORM_LAYOUT_CREATE_CONFIG, validationSchema } from '../../utils/formConfig';
import { defaultSDCreate } from '../../utils/constants';

const AddScheduledDowntime: React.FC<{}> = () => {
	const { showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();

	return (
		<FormBuilder
			data={defaultSDCreate}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CREATE_CONFIG}
			layoutConfig={FORM_LAYOUT_CREATE_CONFIG}
		/>
	);
};

export default AddScheduledDowntime;
